/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import i18n from '../../i18n';

export const getLanguage = () => i18n.language || window.localStorage.i18nextLng;
